export default {
  fn: (value) => value < 0 || value > 4294967295,
  message: 'uint32 type columns must fall between 0 and 4294967295'
};
